module.exports = __webpack_public_path__ + "img/express-transport-belt.ffaf310a.png";